import { AdminShell, PageLoader } from '../../../components';
import { useAdminAddProductsLogic } from './logic';
import ProductForm from './productForm/ProductForm';

export const AddProduct = () => {
	const { isLoading, formik } = useAdminAddProductsLogic();

	return (
		<AdminShell pageTitle="Add Product">
			{isLoading ? <PageLoader /> : <ProductForm formik={formik} />}
		</AdminShell>
	);
};

export default AddProduct;
